import { useRouter } from 'next/router';

import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';

export const useForceHideBrandCollection = () => {
  const { asPath } = useRouter();

  const isPSGCollectionGridEnabled = useFeatureFlag(
    FeatureFlags.TEMP_WEB_ENABLE_PSG_COLLECTION_GRID,
  );
  const isManifestoCollectionEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_MANIFESTO_COLLECTION);

  if (asPath?.includes('/brand/paris-saint-germain')) {
    return !isPSGCollectionGridEnabled;
  }
  if (asPath?.includes('/manifesto')) {
    return !isManifestoCollectionEnabled;
  }

  return false;
};
